import List from "../../layout/List/List";

import styles from "./InstallmentPlanMortgage.module.scss";

const InstallmentPlanMortgage = () => {
  return (
    <main className={styles.installmentPlanMortgage}>
      
      <section
        className="container">
<h3 className={styles.installmentPlanMortgage__listTitle}>
              Kredyt inwestycyjny hipoteczny na zakup nieruchomości za granicą
            </h3>
        <div className={styles.installmentPlanMortgage__container}>
         
        
        <div className={styles.installmentPlanMortgage__list}>          
                     
          <List
            ItemclassName={styles.installmentPlanMortgage__listItem}
            list={[
              "Kredyt hipoteczny może być ukierunkowany lub nieukierunkowany.",
              "Środki finansowe przeznaczane są na zakup nieruchomości w UE",
              "Ubezpieczenie mienia",
              "Regularny i stabilny dochód",
              "Etyka bezproblemowych płatności",
            ]}
          />
        </div>
        <div className={styles.installmentPlanMortgage__contactBlock}>          
            <p className={styles.installmentPlanMortgage__contactInfoTxt}>
              <span>
                Każdy zakup nieruchomości jest wyjątkowy, co oznacza, że jego
                finansowanie jest również skrojone pod konkretną nieruchomość
              </span>
              <span>
                Dobierzemy konkretne opcje finansowania nieruchomości Twoich
                marzeń, w górach lub nad morzem.
              </span>
            </p>          
        </div>
        </div>
      </section>
    </main>
  );
};

export default InstallmentPlanMortgage;
